const ON_DIALOG_SUBMIT = 'fulcrum/containers/Project/GreenlightReport/ON_DIALOG_SUBMIT'
const ON_DIALOG_CANCEL = 'fulcrum/containers/Project/GreenlightReport/ON_DIALOG_CANCEL'

const UPDATE_ACTION_TYPE = 'fulcrum/container/Project/GreenlightReport/UPDATE_ACTION_TYPE'
const UPDATE_PROJECT = 'fulcrum/container/Project/GreenlightReport/UPDATE_PROJECT'
const UPDATE_REVISIONS = 'fulcrum/container/Project/GreenlightReport/UPDATE_REVISIONS'
const UPDATE_CURRENT_REVISION = 'fulcrum/container/Project/GreenlightReport/UPDATE_CURRENT_REVISION'
const UPDATE_DIALOG_ACTIVE = 'fulcrum/containers/Project/GreenlightReport/UPDATE_DIALOG_ACTIVE'

const CHANGE_REVISION = 'fulcrum/container/Project/GreenlightReport/CHANGE_REVISION'
const SUBMIT_APPROVAL = 'fulcrum/container/Project/GreenlightReport/SUBMIT_APPROVAL'

const FETCH_PROJECT = 'fulcrum/container/Project/GreenlightReport/FETCH_PROJECT'
const FETCH_PROJECT_START = 'fulcrum/container/Project/GreenlightReport/FETCH_PROJECT_START'
const FETCH_PROJECT_SUCCESS = 'fulcrum/container/Project/GreenlightReport/FETCH_PROJECT_SUCCESS'
const FETCH_PROJECT_ERROR = 'fulcrum/container/Project/GreenlightReport/FETCH_PROJECT_ERROR'

const FETCH_REVISIONS = 'fulcrum/container/Project/GreenlightReport/FETCH_REVISIONS'
const FETCH_REVISIONS_START = 'fulcrum/container/Project/GreenlightReport/FETCH_REVISIONS_START'
const FETCH_REVISIONS_SUCCESS = 'fulcrum/container/Project/GreenlightReport/FETCH_REVISIONS_SUCCESS'
const FETCH_REVISIONS_ERROR = 'fulcrum/container/Project/GreenlightReport/FETCH_REVISIONS_ERROR'

const FETCH_APPROVALS = 'fulcrum/container/Project/GreenlightReport/FETCH_APPROVALS'
const FETCH_APPROVALS_START = 'fulcrum/container/Project/GreenlightReport/FETCH_APPROVALS_START'
const FETCH_APPROVALS_SUCCESS = 'fulcrum/container/Project/GreenlightReport/FETCH_APPROVALS_SUCCESS'
const FETCH_APPROVALS_ERROR = 'fulcrum/container/Project/GreenlightReport/FETCH_APPROVALS_ERROR'

const POST_APPROVALS = 'fulcrum/container/Project/GreenlightReport/POST_APPROVALS'
const POST_APPROVALS_START = 'fulcrum/container/Project/GreenlightReport/POST_APPROVALS_START'
const POST_APPROVALS_SUCCESS = 'fulcrum/container/Project/GreenlightReport/POST_APPROVALS_SUCCESS'
const POST_APPROVALS_ERROR = 'fulcrum/container/Project/GreenlightReport/POST_APPROVALS_ERROR'
const COMPLETE = 'complete'
const GREENLIGHT_STATES = Object.freeze({
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
})

const CLEAR_PROJECT = 'fulcrum/container/Project/GreenlightReport/CLEAR_PROJECT'
const CLEAR_REVISIONS = 'fulcrum/container/Project/GreenlightReport/CLEAR_REVISIONS'
const CLEAR_CURRENT_REVISION = 'fulcrum/container/Project/GreenlightReport/CLEAR_CURRENT_REVISION'

const TESTS = Object.freeze([
  'desktopGreenlight0',
  'notebookGreenlight0'
])

export {
  CLEAR_PROJECT,
  CLEAR_REVISIONS,
  CLEAR_CURRENT_REVISION,
  CHANGE_REVISION,
  SUBMIT_APPROVAL,
  UPDATE_REVISIONS,
  UPDATE_CURRENT_REVISION,
  UPDATE_PROJECT,
  FETCH_REVISIONS,
  FETCH_REVISIONS_START,
  FETCH_REVISIONS_SUCCESS,
  FETCH_REVISIONS_ERROR,
  FETCH_APPROVALS,
  FETCH_APPROVALS_START,
  FETCH_APPROVALS_SUCCESS,
  FETCH_APPROVALS_ERROR,
  POST_APPROVALS,
  POST_APPROVALS_START,
  POST_APPROVALS_SUCCESS,
  POST_APPROVALS_ERROR,
  FETCH_PROJECT,
  FETCH_PROJECT_START,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_ERROR,
  TESTS,
  GREENLIGHT_STATES,
  COMPLETE,
  ON_DIALOG_SUBMIT,
  ON_DIALOG_CANCEL,
  UPDATE_DIALOG_ACTIVE,
  UPDATE_ACTION_TYPE,
}
